import * as React from 'react'

interface IProps {
    prompt: string;
    placeholder: string;
    searchString: string;
}

interface IState {

}

export class SearchPreview extends React.Component<IProps, IState> {
    render() {
        const {
            placeholder,
            searchString
        } = this.props;

        return (
            <div className={'advanced-search-preview-input ' + (!searchString && 'placeholder')}>
                {searchString ? searchString : placeholder}
            </div>
        )
    }
}